import React, { Component } from 'react';

// redux
import { connect } from 'react-redux';

// phrases
import phrases from './feedback.phrases';

// usersnap service
import { openUsersnap } from 'services/tracking/usersnap.service';

// styles
import './feedback.css';

class Feedback extends Component {
	handleFeedbackClick() {
		openUsersnap();
	}

	render() {
		const { isNavigationToggled } = this.props;

		return isNavigationToggled ? null : (
			<div className="feedback" onClick={this.handleFeedbackClick}>
				{phrases.FEEDBACK}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	isNavigationToggled: state.navigation.isNavigationToggled,
});

export default connect(mapStateToProps)(Feedback);
